export var single = [
  {
    "name": "Invoice",
    "value": 8940000
  },
  {
    "name": "Credit Notes",
    "value": 5000000
  },
  {
    "name": "Purchase",
    "value": 7200000
  },
  {
    "name": "Estimate",
    "value": 6200000
  },
  {
    "name": "Delivery Challan",
    "value": 4200000
  },
  {
    "name": "Delivery Notes",
    "value": 8200000
  }
];